import { Location } from 'history';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { Button, Link, Stack, Typography } from '@rossum/ui/material';
import { useCreateProviderUrl } from '../useCreateProviderUrl';
import { SsoProvider } from '../useDomainSettings';

type AuthProvidersProps = {
  authProviders: SsoProvider[];
  domain: string;
};

export const AuthProviders = ({
  authProviders,
  domain,
}: AuthProvidersProps) => {
  const intl = useIntl();
  const { state = {} } = useLocation<{ referrer?: Location }>();
  const { referrer } = state;

  const createProviderUrl = useCreateProviderUrl({ referrer, domain });

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{ mt: -2 }}
      >
        {intl.formatMessage({ id: 'containers.login.separator' })}
      </Typography>
      {authProviders.map(authProvider => {
        return (
          <Button
            key={authProvider.name}
            component={Link}
            href={createProviderUrl(authProvider)}
            color="secondary"
            variant="outlined"
            sx={{ textAlign: 'center' }}
          >
            {intl.formatMessage(
              {
                id: 'components.authProviders.unknownProvider',
              },
              { authProvider: authProvider.name }
            )}
          </Button>
        );
      })}
    </Stack>
  );
};
